export const FREQUENCY_OPTIONS = [
  { value: '1_time', label: '1 time' },
  { value: '6_months', label: '6 Months' },
  { value: '12_months', label: '12 Months' },
  { value: '24_months', label: '24 Months' },
  { value: '36_months', label: '36 Months' }
];

export const AUDITOR_ORG_OPTIONS = [
  { value: 'INT', label: 'INT' },
  { value: 'CAAT', label: 'CAAT' },
  { value: 'Foreign_CAA', label: 'Foreign CAA' },
  { value: 'IOSA', label: 'IOSA' },
  { value: 'Other_Third_Party', label: 'Other Third Party' }
];

export const PURPOSE_OPTIONS = [
  { value: 'scheduled_internal', label: 'Perform scheduled internal audit' },
  { value: 'scheduled_external', label: 'Perform scheduled external audit' },
  { value: 'interim_audit', label: 'Perform interim audit' },
  { value: 'adhoc_inspection', label: 'Perform ad-hoc inspection' },
  { value: 'routine_caat', label: 'Receive routine inspection from CAAT' },
  { value: 'scheduled_caat', label: 'Receive scheduled audit from CAAT' },
  { value: 'other_authority', label: 'Receive audit/inspection from other authority' }
];

export const AUDIT_METHOD_OPTIONS = [
  { value: 'records_review', label: 'Records review' },
  { value: 'audit_interview', label: 'Audit Interview' },
  { value: 'sampling', label: 'Sampling' },
  { value: 'physical_inspection', label: 'Physical inspection' },
  { value: 'telephone_audit', label: 'Telephone audit' }
];

export const INTERNAL_DEPARTMENT_OPTIONS = [
  { value: 'all', label: 'All Departments' },
  { value: 'CAB', label: 'CAB' },
  { value: 'CGO', label: 'CGO' },
  { value: 'FLT', label: 'FLT' },
  { value: 'DSP', label: 'DSP' },
  { value: 'GRH', label: 'GRH' },
  { value: 'MNT', label: 'MNT' },
  { value: 'SSQ', label: 'SSQ' },
  { value: 'TRG', label: 'TRG' }
];

export const INTERNAL_SCOPE_OPTIONS = [
  { value: 'full_iosa', label: 'Full IOSA' },
  { value: 'org_1', label: 'ORG 1: Management and Control' },
  { value: 'org_2', label: 'ORG 2: Documentation and Records' },
  { value: 'org_3', label: 'ORG 3: Safety Management' },
  { value: 'org_4', label: 'ORG 4: Emergency Response' },
  { value: 'flt_1', label: 'FLT 1: Management and Control' },
  { value: 'flt_2', label: 'FLT 2: Training and Qualification' },
  { value: 'flt_3', label: 'FLT 3: Line Operations' },
  { value: 'flt_4', label: 'FLT 4: Operations Engineering Specifications' },
  { value: 'dsp_1', label: 'DSP 1: Management and Control' },
  { value: 'dsp_2', label: 'DSP 2: Training and Qualification' },
  { value: 'dsp_3', label: 'DSP 3: Line Operations' },
  { value: 'dsp_4', label: 'DSP 4: Operational Control Requirements and Specifications' },
  { value: 'mnt_1', label: 'MNT 1: Management and Control' },
  { value: 'mnt_2', label: 'MNT 2: Maintenance Control' },
  { value: 'mnt_3', label: 'MNT 3: Technical Records' },
  { value: 'mnt_4', label: 'MNT 4: Maintenance Organizations' },
  { value: 'cab_1', label: 'CAB 1: Management and Control' },
  { value: 'cab_2', label: 'CAB 2: Training and Qualification' },
  { value: 'cab_3', label: 'CAB 3: Line Operations' },
  { value: 'cab_4', label: 'CAB 4: Cabin Systems and Equipment' },
  { value: 'grh_1', label: 'GRH 1: Management and Control' },
  { value: 'grh_2', label: 'GRH 2: Training and Qualification' },
  { value: 'grh_3', label: 'GRH 3: Ground Handling Operations' },
  { value: 'grh_4', label: 'GRH 4: Special Aircraft Operations' },
  { value: 'cgo_1', label: 'CGO 1: Management and Control' },
  { value: 'cgo_2', label: 'CGO 2: Training and Qualification' },
  { value: 'cgo_3', label: 'CGO 3: Acceptance and Handling' },
  { value: 'sec_1', label: 'SEC 1: Management and Control' },
  { value: 'sec_2', label: 'SEC 2: Training and Qualification' },
  { value: 'sec_3', label: 'SEC 3: Security Operations' },
  { value: 'sec_4', label: 'SEC 4: Security Threat and Contingency Management' }
];

export const TYPE_VENDOR_OPTIONS = [
  { value: 'CBS', label: 'CBS (Cabin Supplier / Vendor)' },
  { value: 'CAT', label: 'CAT (Catering)' },
  { value: 'DEI', label: 'DEI (De-Icing)' },
  { value: 'FEL', label: 'FEL (FUEL)' },
  { value: 'GSA', label: 'GSA (Ground Services Agent)' },
  { value: 'MRO', label: 'MRO (Maintenance Repair Organization)' },
  { value: 'PTS', label: 'PTS (Parts)' },
  { value: 'PDT', label: 'PDT (Product)' },
  { value: 'THA', label: 'THA (Technical Handling Agent)' },
  { value: 'TRS', label: 'TRS (Training Supplier/Vendor)' }
];

export const EXTERNAL_SCOPE_OPTIONS = [
  { value: 'passenger_handling', label: 'Passenger Handling' },
  { value: 'ramp_operations', label: 'Ramp Operations' },
  { value: 'fueling', label: 'Fueling' },
  { value: 'cargo_handling', label: 'Cargo handling' },
  { value: 'weight_balance', label: 'Weight and Balance' },
  { value: 'security', label: 'Security' },
  { value: 'deicing', label: 'De-icing' },
  { value: 'flight_ops', label: 'Flight operations/ station dispatch' },
  { value: 'line_maintenance', label: 'Line maintenance' },
  { value: 'air_traffic', label: 'Air traffic services' },
  { value: 'catering', label: 'Catering and Catering Security' },
  { value: 'training', label: 'Training' },
  { value: 'enroute', label: 'Enroute' }
];

export const APPLICABLE_STANDARDS_OPTIONS = [
  { value: 'IOSA', label: 'IOSA' },
  { value: 'NCT', label: 'NCT' },
  { value: 'CAAT', label: 'CAAT' },
  { value: 'Contract', label: 'Contract' },
  { value: 'Other_Authority', label: 'Other Authority' }
];

export const LOCATION_OPTIONS = [
  { value: 'HQ', label: 'HQ' },
  { value: 'BKK', label: 'BKK' },
  { value: 'CKG', label: 'CKG' },
  { value: 'CTU', label: 'CTU' },
  { value: 'DMK', label: 'DMK' },
  { value: 'DLC', label: 'DLC' },
  { value: 'ICN', label: 'ICN' },
  { value: 'KIX', label: 'KIX' },
  { value: 'NKG', label: 'NKG' },
  { value: 'PEK', label: 'PEK' },
  { value: 'SHE', label: 'SHE' },
  { value: 'TAO', label: 'TAO' },
  { value: 'TPE', label: 'TPE' },
  { value: 'TSN', label: 'TSN' },
  { value: 'XIY', label: 'XIY' },
  { value: 'SIN', label: 'SIN' }
];

export const LOGISTIC_REQUIREMENT_OPTIONS = [
  { value: 'airport_pass', label: 'Airport Pass' },
  { value: 'air_ticket', label: 'Air Ticket' },
  { value: 'hotel', label: 'Hotel' },
  { value: 'visa', label: 'Visa' },
  { value: 'internal_auditor', label: 'Internal Auditor' },
  { value: 'external_auditor', label: 'External Auditor' },
  { value: 'ppe', label: 'PPE' },
  { value: 'vaccinations', label: 'Vaccinations' }
];

export const SCHEDULE_STATUS_OPTIONS = [
  { value: 'Not Scheduled', label: 'Not Scheduled' },
  { value: 'Scheduled', label: 'Scheduled' },
  { value: 'Deferred', label: 'Deferred' },
  { value: 'Confirmed', label: 'Confirmed' },
  { value: 'Overdue', label: 'Overdue' },
  { value: 'Performed', label: 'Performed' },
  { value: 'Closed', label: 'Closed' },
  { value: 'Cancelled', label: 'Cancelled' }
];

export const YES_NO_OPTIONS = [
  { value: 'Y', label: 'Yes' },
  { value: 'N', label: 'No' }
];
